import { useEffect } from 'react';
import { getDomain } from '../utils/urls';
import { useQueryData } from './useQueryData';
import { useState } from 'react';
// @ts-expect-error - JS file
import { disableHubSpotCookieBanner } from '../utils/disableHubSpotCookieBanner';
import { setLoginMetadataCookieEnableAll, getReauthCookieValue } from '../utils/cookies';
import Raven from 'raven-js';
import { useLocation } from 'react-router-dom';
export const useMobileReauthCookie = () => {
  const [isMobileLogin, setIsMobileLogin] = useState(true);
  const {
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const reauthParam = searchParams.get('reauth');
  if (reauthParam) {
    Raven.captureMessage('Reauth query param', {
      extra: {
        reauthParam
      }
    });
  }
  const {
    allQueryParams
  } = useQueryData();
  const reauth = allQueryParams.reauth;
  useEffect(() => {
    try {
      if (reauth) {
        const reauthCookie = Array.isArray(reauth) ? reauth[0] : reauth;
        Raven.captureMessage('Reauth query param is present', {
          extra: {
            reauthCookie
          }
        });
        document.cookie = `hs_reauth=${reauthCookie}; path=/; secure; domain=${getDomain()}; max-age=300`;
        setLoginMetadataCookieEnableAll();
        disableHubSpotCookieBanner();
        setIsMobileLogin(true);
        const reauthCookieValue = getReauthCookieValue();
        if (reauthCookieValue && reauthCookieValue === reauthCookie) {
          Raven.captureMessage('reauth cookie set and can be found');
        }
      } else {
        setIsMobileLogin(false);
      }
    } catch (e) {
      Raven.captureMessage('Error setting reauth cookie', {
        extra: {
          error: e,
          reauth
        }
      });
    }
  }, [reauth]);

  // Temporary logging - will remove once mobile hs_reauth cookie issue is resolved
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cookieStore = window.cookieStore;
    if (!cookieStore) {
      return;
    }
    let previousValue = getReauthCookieValue();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCookieChange = event => {
      var _event$deleted, _event$changed;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const deleted = (_event$deleted = event.deleted) === null || _event$deleted === void 0 ? void 0 : _event$deleted.find(c => c.name === 'hs_reauth');
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const changed = (_event$changed = event.changed) === null || _event$changed === void 0 ? void 0 : _event$changed.find(c => c.name === 'hs_reauth');
      if (deleted) {
        Raven.captureMessage('hs_reauth cookie removed', {
          extra: {
            previousValue
          }
        });
        previousValue = undefined;
      } else if (changed) {
        Raven.captureMessage('hs_reauth cookie changed', {
          extra: {
            previousValue,
            currentValue: changed.value
          }
        });
        previousValue = changed.value;
      }
    };
    cookieStore.addEventListener('change', handleCookieChange);
    return () => cookieStore.removeEventListener('change', handleCookieChange);
  }, []);
  return isMobileLogin;
};